import { VocabularySlot } from "../enums/VocabularySlot";

/** A singular / plural word pair. */
export interface VocabularyWordPair {
  one: string;
  other: string;
}

const pairs = (
  ...terms: Array<[string, string]>
): Record<VocabularySlot, VocabularyWordPair> => {
  const slots = Object.values(VocabularySlot);
  return Object.fromEntries(
    slots.map((slot, index) => [slot, { one: terms[index][0], other: terms[index][1] }])
  ) as Record<VocabularySlot, VocabularyWordPair>;
};

/**
 * The Default preset, mirrored from the backend `VocabularyPresets` so the app
 * never shows an empty word before the organization loads (or for screens
 * outside the signed-in app). Order: member, session, instructor,
 * occurrence, group, visit, programme.
 */
export const DEFAULT_VOCABULARY: Record<string, Record<VocabularySlot, VocabularyWordPair>> = {
  en: pairs(["Member", "Members"], ["Session", "Sessions"], ["Instructor", "Instructors"],
    ["Occurrence", "Occurrences"], ["Group", "Groups"], ["Visit", "Visits"], ["Programme", "Programmes"]),
  de: pairs(["Mitglied", "Mitglieder"], ["Termin", "Termine"], ["Lehrkraft", "Lehrkräfte"],
    ["Termin", "Termine"], ["Gruppe", "Gruppen"], ["Besuch", "Besuche"], ["Programm", "Programme"]),
  uk: pairs(["Учасник", "Учасники"], ["Сеанс", "Сеанси"], ["Інструктор", "Інструктори"],
    ["Заняття", "Заняття"], ["Група", "Групи"], ["Відвідування", "Відвідування"], ["Програма", "Програми"]),
  pl: pairs(["Uczestnik", "Uczestnicy"], ["Zajęcia", "Zajęcia"], ["Instruktor", "Instruktorzy"],
    ["Termin", "Terminy"], ["Grupa", "Grupy"], ["Wizyta", "Wizyty"], ["Program", "Programy"]),
  ja: pairs(["メンバー", "メンバー"], ["セッション", "セッション"], ["講師", "講師"],
    ["開催日", "開催日"], ["グループ", "グループ"], ["出席", "出席"], ["プログラム", "プログラム"]),
  // Arabic is read-only (the organization cannot rename it): the singular stands indefinite
  // ("لكل مدرّب"), the plural carries the article, as the ar strings use it ("ما يراه الأعضاء").
  ar: pairs(["عضو", "الأعضاء"], ["جلسة", "الجلسات"], ["مدرّب", "المدرّبون"],
    ["موعد", "المواعيد"], ["مجموعة", "المجموعات"], ["زيارة", "الزيارات"], ["برنامج", "البرامج"]),
};
